export const MAX_AVATARS = 5
export const MIN_AVATARS = 1
